// extracted by mini-css-extract-plugin
export default {"projectViewer":"ProjectViewerModal_projectViewer__b-Tbv","closeIcon":"ProjectViewerModal_closeIcon__rHURI","content":"ProjectViewerModal_content__EMgsp"};